document.addEventListener("DOMContentLoaded", function(event) {
    if(window !== window.top){
        // hide one signal icon when page is in iframe
        document.body.classList.add("iframe-page");
        var css = document.createElement("style");
        css.innerHTML = "body.iframe-page #onesignal-bell-container { display : none !important }";
        document.body.appendChild(css);
    }
});
